<template>
  <v-app>
    <v-snackbar
      :timeout="timeout"
      v-model="snackbar"
      :color="alert.color"
      top
    >
      <v-icon color="white" class="mr-3">{{ alert.type }}</v-icon>
      {{ alert.message }}
      <v-btn color="white" flat small @click.native="snackbar = false">
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>
    <v-slide-y-transition mode="out-in">
      <router-view></router-view>
    </v-slide-y-transition>
  </v-app>
</template>

<script>
  export default {
    data() {
      return {
        // NOTE: 알림창 속성
        snackbar: false,  // 상단 알림창
        timeout: 3000,    // 알림창 유지시간
        top: true,        // 알림창 위치
        alert: {},        // 알림창 { type: 아이콘, color: 알림창 배경색상, message: 내용 }
      };
    },
    mounted() {
      const that = this;
      // const user = null;

      // NOTE: 알림 이벤트 청취
      this.$eventBusAlert.$on('alertOccur', (alert) => {
        that.alert = alert;
        that.snackbar = true;
      });

      // NOTE: 페이지 이동 알림
      this.$eventBusAlert.$on('alertClose', () => {
        that.snackbar = false;
      });
    },
  };
</script>

<style lang="scss" src="styles/reset.scss"></style>
<style lang="scss" src="styles/common.scss"></style>



// WEBPACK FOOTER //
// src/App.vue